/** @format */
import { Heading } from '@mpb-com/feather/components/atoms/heading';
import {
    HeadingColor,
    HeadingSize,
    HighlightColor,
} from '@mpb-com/feather/components/atoms/heading/types';
import {
    Skeleton,
    SkeletonVariant,
} from '@mpb-com/feather/components/atoms/skeleton';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { renderMarkdown } from '@toucan/client/shared/helpers/markdown';

import { styles } from './block-title.styles';
import { BlockTitleProps, StyledBlockTitleProps } from './types';

const StyledBlockTitle = styled.div<StyledBlockTitleProps>`
    ${styles}
`;

export const BlockTitle: FunctionComponent<BlockTitleProps> = ({
    pretitle,
    title,
    showPretitle,
    headingColor = HeadingColor.TEXT_SECONDARY,
    highlightColor = HighlightColor.TEXT_ACCENT_INVERSE,
    isLoading,
    className,
}) => {
    if (isLoading) {
        return (
            <StyledBlockTitle className={className}>
                {showPretitle && (
                    <small className="pretitle">
                        <Skeleton
                            variant={SkeletonVariant.TEXT}
                            data-testid="pretitle-skeleton"
                        />
                    </small>
                )}

                <Heading size={HeadingSize.H3} className="title">
                    <Skeleton
                        variant={SkeletonVariant.TEXT}
                        data-testid="title-skeleton"
                    />
                </Heading>
            </StyledBlockTitle>
        );
    }

    return (
        <StyledBlockTitle headingColor={headingColor} className={className}>
            {showPretitle && <small className="pretitle">{pretitle}</small>}

            <Heading
                size={HeadingSize.H3}
                className="title"
                highlightColor={highlightColor}
                color={headingColor}
            >
                {renderMarkdown(title)}
            </Heading>
        </StyledBlockTitle>
    );
};
